import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLogoZipSimple = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 70,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5.057 10.587 21.313H23V28H0v-5.056L12.413 6.686H0V0h23v5.057ZM31 28h8V0h-8v28ZM62 9.457C62 7.094 60.433 6 58.577 6H54v7h4.577C60.433 13 62 11.819 62 9.457Zm8 .113c0 6.101-4.19 9.654-11.386 9.654h-4.74V28H46V0h12.614C65.81 0 70 3.468 70 9.57Z",
    fill: props.color || "#FC0F42"
  })
}));
export default SvgLogoZipSimple;